import React, { createContext, useContext, useEffect, useState } from "react";

const RetractableMenuContext = createContext();

/**
 * Provider component for the RetractableMenu
 * 
 * @param {React.ReactNode} children - The child component that will have access to the context 
 */
function RetractableMenuProvider({ children }) {
  // Check if screen is small
  const isMediumDevices = window.innerWidth <= 768;

  // Sidebar expansion state
  const [isExpanded, setIsExpanded] = useState(isMediumDevices ? false : true);
  const [isSmallScreen, setIsSmallScreen] = useState(isMediumDevices);

  // Toggle the sidebar's expanded state
  function onClickMenuIcon() {
    setIsExpanded((expanded) => !expanded);
  }

  // Automatically collapse the sidebar after click on small screens
  function closeMenuAfterClick() {
    if (isSmallScreen) {
      setIsExpanded(false);
    }
  }

  // Update isSmallScreen based on window size
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <RetractableMenuContext.Provider value={{ isExpanded, onClickMenuIcon, closeMenuAfterClick }}>
      {children}
    </RetractableMenuContext.Provider>
  );
}

function useRetractableMenu() {
  const context = useContext(RetractableMenuContext);

  if (context === undefined)
    throw new Error(
      "RetractableMenuContext was used outside of RetractableMenuProvider"
    );

  return context;
}

export { useRetractableMenu, RetractableMenuProvider };
